import { MagnifyingGlass } from "@phosphor-icons/react";
import { PickerSearchProps } from "../types";

export const PickerSearch = ({ value, onChange, placeholder, autoFocus = true }: PickerSearchProps) => {
  return (
    <div className="mb-4">
      <div className="relative">
        <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-secondary-mid pointer-events-none" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 text-sm border border-muted-foreground/20 rounded-lg bg-muted focus:outline-hidden focus:bg-muted focus:border-moss-primary focus:ring-2 focus:ring-moss-primary/20 transition-all duration-200 placeholder:text-neutral-secondary-mid"
          autoFocus={autoFocus}
        />
      </div>
    </div>
  );
};